<template>
    <layout>
        <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
        <div slot="content">
            <div class="pop-content-search">
                <el-form size="mini" label-width="120px" style="margin-left: -55px;">
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="고객구분">
                                <el-select v-model="form.custType">
                                    <el-option
                                    v-for="item in custGbList"
                                    :key="item.value"
                                    :label="item.value"
                                    :value="item.key">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="16">
                            <el-form-item label="사이트명">
                                <el-row>
                                    <el-col :span="8">
                                        <el-input type="text" v-model="form.siteNm1" @keyup.native.enter="selectCust('S1')"></el-input>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-input type="text" v-model="form.siteNm2" @keyup.native.enter="selectCust('S2')"></el-input>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-input type="text" v-model="form.siteNm3" @keyup.native.enter="selectCust('S3')"></el-input>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="신고자명">
                                <el-input type="text" v-model="form.custNm" @keyup.native.enter="selectCust('CUSTNM')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="전화번호">
                                <el-input type="text" v-model="form.telNo" @keyup.native.enter="selectCust('TELNO')"></el-input>
                                <el-input type="text" v-model="form.boundTelNo" v-show="false"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="방번호">
                                <el-input type="text" v-model="form.cyberRoomId"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="1">
                        </el-col>
                        <el-col :span="3">
                            <el-button type="primary" size="mini" icon="el-icon-document-add" @click="selectCust">
                                 <!-- {{$t('search')}} -->
                                {{ this.$i18n.messages[this.$store.state.locale].search }}
                            </el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <div class="grid-wrap">
                <div class="table-area">
                    <div class="table-b">
                        <ag-grid-vue 
                            ref="grid" 
                            :style="gridStyle"
                            class="ag-theme-alpine"
                            row-selection="single"
                            :column-defs="columnDefs"
                            :grid-options="gridOptions"
                            :row-data="rowData"
                            :default-col-def="defaultColDef"
                            :framework-components="frameworkComponent"
                            :statusBar="statusBar"
                            @grid-ready="onReady"
                            @cell-clicked="onCellClicked" />
                    </div>
                </div>
            </div>

            <div class="table-header">
                <div class="table-name">
                    <h3 class="ico_table_name">{{ `신규사이트 등록정보` }}</h3>
                </div>
            </div>
            <el-form class="el-sub-form" size="mini" label-width="120px">
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="고객구분">
                            <el-select v-model="form.subCustGb">
                                <el-option
                                v-for="item in subCustGbList"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="지역구분">
                            <el-select v-model="form.area" @change="getCombo">
                                <el-option value='' label="전체">전체</el-option>
                                <el-option
                                v-for="item in areaIdList"
                                :key="item.value"
                                :label="item.value"
                                :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="센터명">
                            <el-select v-model="form.asAgent">
                                <el-option value='' label="전체">전체</el-option>
                                <el-option
                                v-for="item in asAgentList"
                                :key="item.value"
                                :label="item.value"
                                :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-form-item label="사이트명">
                        <el-col :span="8">
                            <el-input type="text" v-model="form.subSiteNm1"></el-input>
                        </el-col>
                        <el-col :span="8">
                            <el-input type="text" v-model="form.subSiteNm2"></el-input>
                        </el-col>
                        <el-col :span="8">
                            <el-input type="text" v-model="form.subSiteNm3"></el-input>
                        </el-col>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="주소">
                        <el-col :span="8">
                            <el-col :span="18">
                                <el-input type="text" v-model="form.subZipCd" readonly></el-input>
                            </el-col>
                            <el-col :span="2">
                                <el-button type="primary" icon="el-icon-search" @click="addrOpenPopUp"></el-button>
                            </el-col>
                        </el-col>
                        <el-col :span="8">
                            <el-input type="text" v-model="form.subAddr1"></el-input>
                        </el-col>
                        <el-col :span="8">
                            <el-input type="text" v-model="form.subAddr2"></el-input>
                        </el-col>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="고객명">
                            <el-input type="text" v-model="form.chargeNm"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="전화번호">
                            <el-input type="text" v-model="form.subTelNo"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="핸드폰">
                            <el-input type="text" v-model="form.subHpNo"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="MA구분">
                            <el-select v-model="form.maYn">
                                <el-option
                                v-for="item in maYnList"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="유/무상">
                            <el-select v-model="form.payYn">
                                <el-option
                                v-for="item in payYnList"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="방번호">
                            <el-input type="text" v-model="form.subcyberRoomId"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div class="btn-wrap btn-type2 clearfix" style="float: right; margin-top: 5px;">
                <el-button type="primary" size="mini" icon="el-icon-document-add" @click="saveSite">저장</el-button>
                <el-button type="danger" size="mini" icon="el-icon-close" @click="cancelSite">취소</el-button>
            </div>
        </div>
    </layout>
</template>

<script>
import Layout from '@/components/Slot/ModalSlot.vue';
/**
 * * components
 */
 import {AgGridVue} from 'ag-grid-vue';
 import MaskEditCellRenderer from '@/components/agGrid/maskedit-cell-renderer'    

 /**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

function _phone(hp){
    return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}

export default {
    components: {Layout, AgGridVue},
    props: {
        data: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            form: {
                custType: '', /** 고객구분 */
                siteNm1: '',
                siteNm2: '',
                siteNm3: '',
                custNm: '',
                telNo: '',
                hpNo: '',
                boundTelNo: '',
                cyberRoomId: '',
                subCustGb: '',
                subRegionCd: '',
                area: '',  /** 지역구분 */
                areaId: '',  /** 지역구분 */
                asAgent: '', /** 센터명 */
                subZipCd: '', /** 우편번호 */
                subAddr1: '',
                subAddr2: '',
                subSiteNm1: '',
                subSiteNm2: '',
                subSiteNm3: '',
                chargeNm: '', /** 고객명 */
                subTelNo: '',
                subCustMobile: '',
                maYn: '',
                payYn: '',
                subcyberRoomId: '',
                serialNo: ''
            },
            custGbList: [{key: '', value: '전체'}, {key: '01', value: '일반'}],
            subCustGbList: [{key: '01', value: '일반'}],
            subRegionCdList: [{key: '', value: '전체'}, {key: '01', value: '강원'}],
            areaList: [], /** 지역구분 */
            areaIdList: [], /** 지역구분 */
            asAgentList: [], /** 센터명 */
            maYnList: [],
            payYnList: [],
            // AG-GRID OPTION [START]
            rowData: [],
            gridStyle : 'width: 100%;height: 400px; min-height:100px;',
            defaultColDef: {
                resizable: true
                , filter:false
                , sortable: true
            },
            gridApi: null,
            columnApi: null,
            columnDefs: [],
            gridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            frameworkComponent : {
                maskEdit: MaskEditCellRenderer,
            },
            statusBar: null,
            //AG-GRID OPTION [END]
        }
    },
    computed: {
        title() {
            return `고객조회`;
        }
    },
    created() {
        this.statusBar = {
        statusPanels: [
            { statusPanel: 'agTotalRowCountComponent', align: 'right' },
        ],
        };
    },
    mounted() {
        this.form = {
            ...this.form,
            ...this.data
            };

        console.log('custSelect mount : ', this.data);
        console.log('custSelect mount form : ', this.form);

        this.getCombo({flag: 'INIT'});
        this.createColumnDefs();
    },
    methods: {
        onReady(params) {
            //그리드용 api 정의
            this.gridApi = params.api;
            this.columnApi = params.columnApi;

            //this.gridApi.sizeColumnsToFit();
        },
        createColumnDefs() {
            this.columnDefs = [
                {
                    headerName:'고객구분',
                    field:'custTypeNm', 
                    width:130,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'사이트명',
                    field:'siteNms', 
                    width:180,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'주소',
                    field:'addr', 
                    width:180,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'고객명',
                    field:'chargeNm', 
                    width:130,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'고객전화번호',
                    field:'chargeTelNo', 
                    width:180,
                    cellStyle:{textAlign: 'center'}
                },
                {
                    headerName:'신고자명',
                    field:'custNm', 
                    width:130,
                    cellStyle:{textAlign: 'center'},
                    cellRenderer: 'datePicker'
                },
                {
                    headerName:'신고자전화번호',
                    field:'telNo',  
                    width:180,
                    cellStyle:{textAlign: 'center'}
                },
                {
                    headerName:'연락처',
                    field:'telNo2',  
                    width:180,
                    cellStyle:{textAlign: 'center'}
                },
                {
                    headerName:'발신번호',
                    field:'boundTelNo', 
                    width:190,
                    cellStyle:{textAlign: 'center'}
                },
                {
                    headerName:'핸드폰',
                    field:'hpNo', 
                    width:190,
                    cellStyle:{textAlign: 'center'}
                },
                {
                    headerName:'제조번호',
                    field:'serialNo', 
                    width:190,
                    cellStyle:{textAlign: 'center'}
                }
            ];
        },
        onCellClicked(params) {
            const idx = params.rowIndex;
            const field = params.colDef.field;
            console.log('고객팝업 onCellClicked params',this.form.serialNo, params);

            if(this.form.serialNo != ''){
                params.data.serialNo = this.form.serialNo;
            }

            this.$emit('close', params.data);
            this.closeModal();
            
        },
        closeModal() {
            this.$parent.close();
        },
        getCombo(param) {
            const vm = this
            if(param.flag === 'INIT'){
                // 고객구분
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: 10}})
                    .then(response => {
                        this.custGbList = _.cloneDeep(response.data) || [];
                        this.custGbList.unshift({key:undefined, value:'선택'});
                        this.subCustGbList = _.cloneDeep(response.data) || [];
                        this.form.subCustGb = response.data && response.data.length>0 ? response.data[0].key : '';
                    })
                    .finally(() => {
                        //호출하는 부모창에서 설정하기 때문에 주석처리
                        //this.form.custType = 'Default' /** 디폴트 일반선택 */

                        // 조회버튼(SEARCH_BUT)을 제외하고 나머지일때 조회함수 호출
                        if(this.data.eventFrom != 'SEARCH_BUT'){
                            this.selectCust(this.data.eventFrom);
                        }
                    });

                // 지역구분 : AreaAgent 1레벨
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: 217}})
                    .then(response => {
                        this.areaList = response.data || []
                        this.areaList.unshift({key:undefined, value:'선택'})
                    })
                    .finally(() => {});
                
                // 지역구분 : AreaAgent 1레벨
                this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: 217}})
                    .then(response => {
                        this.areaIdList = response.data || []
                        this.areaIdList.unshift({key:undefined, value:'선택'})
                    })
                    .finally(() => {});

                // MA구분 : MaYn 1레벨
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: 75}})
                    .then(response => {
                        this.maYnList = response.data || []
                        
                    })
                    .finally(() => {
                        if(this.maYnList && this.maYnList.length > 0){
                            this.form.maYn = this.maYnList[0].key
                        }
                    });        

                // MA구분 : MaYn 1레벨
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: 50}})
                    .then(response => {
                        this.payYnList = response.data || []
                        if(this.payYnList && this.payYnList.length > 0){
                            this.form.payYn = this.payYnList[0].key
                        }
                    })
                    .finally(() => {});        
    

            } else {
                
                console.log('asAgentList===ss=', this.form.asAgent, this.asAgentList )
                
                this.asAgentList = [{key:'', value:'선택' }]
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: vm.form.area}})
                    .then(response => {
                        // vm.form.asAgent = ''
                        let vTemp =  JSON.parse(JSON.stringify(response.data))
                        vTemp.unshift({key:'', value:'선택'})

                        vm.asAgentList = vTemp || []
                        vm.form.asAgent = ''
                    })
                    .finally(() => {
                        
                    });
            }
        },
        async selectCust(param){
            if(param === 'S1' || param === 'S2' || param === 'S3' || param === 'CUSTNM' || 
                param === 'TELNO' || param === 'HPNO' || param === 'BOUNDTELNO' || this.form.serialNo != '' || param === 'IN_BOUND' ){
                   
                // 사이트명을 입력후 엔터키를 통해서 조회시 초기화 필요
                if(param != 'CUSTNM') this.form.custNm = '';
                if(!(param === 'TELNO' || param === 'IN_BOUND')) this.form.telNo = '';

                this.form.custId = '';
                if(param != 'HPNO') this.form.hpNo = '';
                if(param != 'BOUNDTELNO') this.form.boundTelNo = '';

                this.form.zipCd1 = '' 
                this.form.addr1 = '' 
                this.form.addr2 = '' 
                this.form.asAgentNm  = '' 
                this.form.maYn  = '' 
                this.form.payYnNm  = '' 
                this.form.cyberRoomId = '' 
                
                if(param === 'S1' || param === 'S2' || param === 'S3' || this.form.serialNo != ''){
                    this.form.custType = '';
                } else {
                    //this.form.custType = 'Default'; //일반
                    this.form.custType = '';
                }

                if(this.form.telNo === '') {
                    this.form.telNo = this.form.boundTelNo;
                    if(this.form.telNo === '') {
                        this.form.telNo = this.form.hpNo;
                    }
                }
            }

            const vform ={
                ...this.form,
                telNo: this.form.telNo.replace(/[^0-9]/g, ''),
                boundTelNo: this.form.boundTelNo.replace(/[^0-9]/g, ''),
                custType: this.form.custType || '',
                boundCustNm: this.form.custNm || '',
                sortType: '',
                page: 1,
                totalpage: 9999,
                totalcount: 9999,
                curPage: 0,
                processTime: ''
            }

            let vRowCnt = 0;
            this.$store.commit('loading');
            console.log('goOpen vform : ', vform);
            await this.$http.post(("/api/asMng/call/selectCustSelPage"), vform
                ).then(response => {
                 console.log('pop : ' ,  response.data);
                 
                this.rowData = response.data.map(x=>{
                    x.siteNms = (x.siteNm1 || '') + ' ' + (x.siteNm2 || '') + ' ' + (x.siteNm3 || '');
                    x.addr = (x.addr1 || '') + ' ' + (x.addr2 || '');
                    x.chargeTelNo = _phone(x.chargeTelNo);
                    x.telNo = _phone(x.telNo);
                    x.telNo2 = _phone(x.telNo2); // 연락처
                    x.hpNo = _phone(x.hpNo);
                    x.boundTelNo = _phone(x.boundTelNo);

                    return x
                });

                vRowCnt = this.rowData.length;
                
            }).finally(() => {
                this.$store.commit('finish');

                if(vRowCnt == 1){
                    this.$emit('close', this.rowData[0]);
                    this.closeModal();
                }
 
            });

        },
        saveSite(){
            /** 저장 */
            
            const vm = this

            if(this.form.subCustGb === ''){
                this.$swal({type: 'warning', text: '고객구분을 선택해 주십시오.'});
                return false
            }

            if(this.form.asAgent === ''){
                this.$swal({type: 'warning', text: '센터를 입력해 주십시오.'});
                return false
            }

            if(this.form.subSiteNm1 === ''){
                this.$swal({type: 'warning', text: '사이트명을 입력해 주십시오.'});
                return false
            }

            if(this.form.subZipCd === ''){
                this.$swal({type: 'warning', text: '우편번호를 입력해 주십시오.'});
                return false
            }

            if(this.form.subAddr1 === '' || this.form.subAddr2 === ''){
                this.$swal({type: 'warning', text: '상세주소를 입력해 주십시오.'});
                return false
            }

            
            if(this.form.chargeNm === ''){
                this.$swal({type: 'warning', text: '담당자명을 입력해 주십시오.'});
                return false
            }

            if(this.form.subTelNo === ''){
                this.$swal({type: 'warning', text: '전화번호를 입력해 주십시오.'});
                return false
            }
        
            if(this.form.maYn === ''){
                this.$swal({type: 'warning', text: 'MA구분을 선택해 주십시오.'});
                return false
            }

            if(this.form.payYn === ''){
                this.$swal({type: 'warning', text: '유/무상을 선택해 주십시오.'});
                return false
            }
            
            this.$swal({
                type: 'warning',
                text: `신규사이트를 저장하시겠습니까?`,
                showCancelButton: true,
                confirmButtonText: '예',
                cancelButtonText: '아니오',
            }).then((result) => {
                if (result.value) {
                    const vform0 = {
                        ...vm.form,
                        siteType: vm.form.subCustGb,
                        siteCd: '',
                        siteNm1: vm.form.subSiteNm1 || '',
                        siteNm2: vm.form.subSiteNm2 || '',
                        siteNm3: vm.form.subSiteNm3 || '',

                        asAgentId: this.$store.state.loginInfo.asAgentId,
                        
                        zipCd: vm.form.subZipCd || '',
                        addr1: vm.form.subAddr1 || '',
                        addr2: vm.form.subAddr2 || '',
                        telNo: vm.form.subTelNo.replace(/[^0-9]/g, ''),
                        hpNo: vm.form.subHpNo ? this.form.subHpNo.replace(/[^0-9]/g, '') : '',
                        boundTelNo: vm.form.boundTelNo.replace(/[^0-9]/g, '')
                    }
                    const vform = JSON.parse(JSON.stringify(vform0))
                    
                    console.log('vform save : ', vform)

                    this.$store.commit('loading')
                    this.$http.put(_url("/api/asMng/call/saveSite"), vform)
                        .then(response => {
                            this.$swal({ type: 'success', text: '신규사이트가 저장되었습니다' });
                    
                        }).catch((e) => {
                            console.error(e);
                            this.$swal({ type: 'success', text: '신규사이트의 저장에 실패 했습니다.' })
                        })
                        .finally(() => {
                            this.$store.commit('finish')
                        });

                }
            });

        },
        cancelSite(){
            /** 취소 */
            this.closeModal();
        },
        addrOpenPopUp(param) {
            /** 주소 조회 */

            const vm = this;

            let vOparam = {};
            if(param === 'ZIP'){
                vOparam = {q: this.form.addr1 + ' ' + this.form.addr2}
            }

            // eslint-disable-next-line no-undef
            new daum.Postcode({
                oncomplete: (data) => {
                    var fullAddr = data.address; //최종 주소 변수
                    var extraAddr = ''; // 조합형 주소 변수
              
                    if(data.userSelectedType === 'R') {
                        if(data.bname) {
                            extraAddr += data.bname;
                        }
                        if(data.buildingName) {
                            extraAddr += (extraAddr ? ', '+ data.buildingName : data.buildingName);
                        }
                        fullAddr += (extraAddr ? ' ('+ extraAddr + ')' : '');
                    } else {
                        fullAddr = data.jibunAddress;
                    }
                    console.log(data)
                    vm.form.subZipCd = data.zonecode;
                    vm.form.subAddr1 = fullAddr;
                    vm.form.subAddr2 = ''; // 초기화

                    vm.reloadAsAgent(data.zonecode);
                }
            }).open(vOparam);
        },
        async reloadAsAgent(vZipCd){
            // 지정센터 재로딩

            let vAllArea = [];
            // 지역/센터 : AreaAgent, CAT_LVL(2)
            await this.$http.get(`/api/asMng/call/topkey`, {params: {topKey: 'AreaAgent'}})
                    .then(response => {
                        vAllArea = _.cloneDeep(response.data) || [];
                    });

            await this.$http.post(`/api/asMng/call/selectServiceEngineerFind`, {zipCd: vZipCd})
            .then(response => {
                
                const vEngineerFindList = response.data;
                if(vEngineerFindList && vEngineerFindList.length>0){
                    const vAreaObj = _.cloneDeep(vAllArea.filter(x=>x.catKey==vEngineerFindList[0].area2));
                    let vParentId = '';
                    
                    if(vAreaObj && vAreaObj.length>0){
                        this.form.area = vAreaObj[0].catId + '';
                        vParentId = vAreaObj[0].catId + '';

                        this.asAgentList = _.cloneDeep(vAllArea.filter(x=>x.parentId==vParentId)
                                                            .map(y=>{
                                                                y.key = y.catKey;
                                                                y.value = y.catNm;
                                                                return y;
                                                            }));
    
                        const vAsAgentObj = vAllArea.filter(x=>x.catKey==vEngineerFindList[0].asAgentId+'');
                        if(vAsAgentObj && vAsAgentObj.length>0){
                            this.form.asAgent = vAsAgentObj[0].catKey+'';
                        } else {
                            this.form.asAgent = '';    
                        }
                        
                    } else {
                        this.asAgentList = [];

                        this.form.area = '';
                        this.form.asAgent = '';
                    }
                    
                } else {
                    this.asAgentList = [];

                    this.form.area = '';
                    this.form.asAgent = '';
                }
            });

        }
    }
}
</script>

<style lang="scss" scoped>
.el-sub-form {
    border: 1px solid #d7d7d7 !important;
    padding: 10px 0px 10px 0px;
    border-radius: 5px; 
    margin-left: 0px;
    .el-form-item {
        margin-left: -35px;
        margin-right: 15px;
    }
}
</style>